import axios from './config/axios'

const getProductInformationByState = (state, groupNumber) => {
  return axios
    .get(`/api/forms/${state}?groupNumber=${groupNumber}`)
    .then(r => r.data)
}
export default getProductInformationByState